import { isPlatformBrowser } from '@angular/common';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { RecipesService } from './../../services/recipes.service';
import { IRecipe } from './../../models/recipes.model';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-recipe-details',
  templateUrl: './recipe-details.component.html',
  styleUrls: ['./recipe-details.component.scss'],
  standalone: true,
  imports: [LottieComponent, MatFormFieldModule, RouterLink, MatIconModule, TranslateModule]
})
export class RecipeDetailsComponent implements OnInit {

  public recipe: IRecipe = {
    recipe_id: 0,
    recipe_title: '',
    recipe_image: '',
    recipe_description: '',
    recipe_type: '',
    recipe_time: '',
    recipe_price: 0,
    recipe_items: 0,
    recipe_portions: 0,
    recipe_ingredients: [],
    recipe_preparation: [],
    recipe_times_saved: 0,
    recipe_times_seen: 0,
    created_at: '',
    updated_at: '',
    category_name: '',
    color: undefined
  };
  public loading = false;

  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private recipesService: RecipesService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
    const recipe = this.activatedRoute.snapshot.params.id;
    const recipeArr = recipe.split('-');
    const id = recipeArr[recipeArr.length - 1];
    this.getRecipe(id);
  }

  public async getRecipe(id: string): Promise<void> {
    this.loading = true;
    try {
      const { data } = await this.recipesService.getRecipeById(id);
      data.color = {
        background: data.color
      };
      this.recipe = data;
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  public goRoute(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

}
